export {
  default,
  initialize,
} from 'ember-in-viewport/initializers/viewport-config';
